module.exports = __webpack_public_path__ + "static/img/cancel_nobg.94590e36.svg";